var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-4 pr-0"},[_c('img',{attrs:{"src":_vm.img,"alt":"screen"}})]),_c('div',{staticClass:"col col-8 pt-2 pr-4"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }